var _path, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderShortcuts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.31,
    y: 2.98,
    width: 26,
    height: 26,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.31,4V28h-24V4h24m2-2h-28V30h28V2Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "21.31 7.98 7.31 7.98 11.81 12.48 5.31 18.98 10.31 23.98 16.81 17.48 21.31 21.98 21.31 7.98"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderShortcuts);
export default __webpack_public_path__ + "static/media/folder-shortcuts.4b98cd52.svg";
export { ForwardRef as ReactComponent };